import { createRoot } from 'react-dom/client'
import { handleResetWebsiteData } from './lib/resetWebsiteData'
import App from './App.tsx'
import './index.css'
import { logger } from './lib/utils'

// Reset persisted form/session/tracking state synchronously before any React mounting
// or downstream module side effects read from storage.
handleResetWebsiteData()

// Log environment variables for debugging
logger.log('Main - Environment variables check:')
logger.log('VITE_SUPABASE_URL:', import.meta.env.VITE_SUPABASE_URL || 'undefined')
logger.log('VITE_SUPABASE_ANON_KEY exists:', !!import.meta.env.VITE_SUPABASE_ANON_KEY)

// Check if environment variables are available
if (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_ANON_KEY) {
  logger.error('Missing environment variables! Please create .env.local file with VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY')
}

createRoot(document.getElementById("root")!).render(<App />);
